import { getRailsClient } from "../../client";

// Verified from GET, POST, and PUT /api/internal_api/v1/admin/custom_latest_changes
// All three return the full updated array of notifications.
export interface BellNotification {
  id: number;
  title: string;
  description: string;
  author: string;
  createdAt: string;
}

export const getBellNotifications = async () => {
  try {
    const API = "/api/internal_api/v1/admin/custom_latest_changes";
    const { data } = await getRailsClient().get<BellNotification[]>(API);
    return data;
  } catch (error) {
    console.error("Error fetching last :", error);
  }
};

export const createBellNotification = async ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  try {
    const API = "/api/internal_api/v1/admin/custom_latest_changes";
    const { data } = await getRailsClient().post<BellNotification[]>(API, { title, description });
    return data;
  } catch (error) {
    console.error("Error creating custom banner:", error);
  }
};

export const updateBellNotification = async ({
  id,
  title,
  description,
}: {
  id: number;
  title: string;
  description: string;
}) => {
  try {
    const API = `/api/internal_api/v1/admin/custom_latest_changes/${id}`;
    const { data } = await getRailsClient().put<BellNotification[]>(API, { title, description });
    return data;
  } catch (error) {
    console.error("Error updating custom banner:", error);
  }
};

export const deleteBellNotifications = async ({ ids }: { ids: number[] }) => {
  try {
    const API = "/api/internal_api/v1/admin/custom_latest_changes/destroy_many";
    await getRailsClient().delete(API, { data: { ids } });
  } catch (error) {
    console.error("Error deleting custom banners:", error);
  }
};
